// Export hook for the company-scoped shift change requests admin listing (ASIS-5238).
// Wraps the generic useExport hook with the current listing filters. Excel-only,
// so a single "Descargar" button drives it — onExport takes no format argument.

import { useTranslation } from 'react-i18next';

import { shiftService } from '@/api/domains/shift';
import type { LC_ExportCompanyShiftRequestsIn } from '@/api/domains/shift/shift.types';
import { useExport } from '@/hooks/ui/useExport';


// ── Params & result types ──────────────────────────────────────────────────
export interface UseShiftChangeRequestsExportParams {
  filters?: LC_ExportCompanyShiftRequestsIn;
}

export interface UseShiftChangeRequestsExportResult {
  onExport: () => Promise<void>;
  isExporting: boolean;
}

// ── Hook ───────────────────────────────────────────────────────────────────
export function useShiftChangeRequestsExport(
  params: UseShiftChangeRequestsExportParams = {},
): UseShiftChangeRequestsExportResult {
  const { t: translate } = useTranslation();
  const { filters = {} } = params;

  const { onExport, isExporting } = useExport({
    exportFn: () => shiftService.exportCompanyShiftRequests(filters),
    successMessage: translate('attendance:shiftChangeAdmin.messages.exportSuccess'),
    errorMessage: translate('attendance:shiftChangeAdmin.messages.exportError'),
  });

  return { onExport, isExporting };
}

export default useShiftChangeRequestsExport;
